var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex justify-content-center full-height full-width align-items-center"},[_c('div',{staticClass:"error-container text-center"},[_c('h2',{staticClass:"semi-bold"},[_vm._v(_vm._s(_vm.msg))]),_vm._v(" "),_c('br'),_c('br'),_c('br'),_c('br'),_c('router-link',{staticStyle:{"text-decoration":"underline"},attrs:{"to":{ name: _vm.ROUTES.ADMIN.ALL_USERS_LIST,
        query: {
          'filters.apartment_id.equal' : 'all',
          'filters.status_enabled.equal' : 'all'
        }}}},[_vm._v("管理画面へ")])],1)])}
var staticRenderFns = []

export { render, staticRenderFns }